module.exports = {"start":"إبدأ","restart":"إعادة اختبار القياس","testing":"#{test} جاري الاختبار","download":"سرعة التحميل","upload":"الرفع","latency":"وقت الإستجابة","jitter":"التقطع","poweredBy":"مدعوم من","mbps":"ميغابت في الثانية","kbps":"كيلوبت في الثانية","ms":"ملي ثانية","s":"","internetPerformanceTest":"","yourIp":"","testServerLocation":"","referenceNumber":"","startTest":"","initialising":"","initiateFail":"كانت هناك مشكلة، يرجى المحاولة مرة أخرى"}


//////////////////
// WEBPACK FOOTER
// ./src/js/i18n/ar-SA.json
// module id = 203
// module chunks = 0